import { Directive } from '@angular/core';

@Directive({
  selector: '[appExpirationMonth]'
})
export class ExpirationMonthDirective {

  constructor() { }

}
